export const getMediaBlockIndexFromId = (mediaId) => {
  return mediaId.includes('media-block') && mediaId.split('-')[2] - 1;
};

export const getMediaIndex = (button: HTMLElement) => {
  const mediaIndexAttr = button.closest('.media-block').getAttribute('data-media-index');
  const mediaIndexFromId = getMediaBlockIndexFromId(button.closest('.media-block').id || '');
  const mediaIndexFromAttr = mediaIndexAttr ? parseInt(mediaIndexAttr, 10) - 1 : 0;
  // if there is no data-media-index attribute on the media-block, get index from the id of 'media-block-n'
  const mediaIndex = mediaIndexFromAttr || mediaIndexFromId || 0;
  // removes the 'media-block-n' id if the attribute exists
  if (mediaIndexFromAttr && mediaIndexFromId) {
    button.closest('.media-block').removeAttribute('id');
  }
  return mediaIndex;
};
